export const nodeBackground = {
  main: { light: "#d0d5d7ff", dark: "#4f5972ff" },
  functionality: { light: "#d0d5d7ff", dark: "#6a738cff" }
};
